// Local translations
export const T = {
  en_GB: {
    edit: "Edit",
    productTypes: "Product Types",
    description:
      "Define instrument categories for this collection. These are used to track client product assessment and for target market suitability checking. The default type is pre-selected when creating a new product.",
    noProductTypes: 'No product types configured. Click "Add Product Type" to create one.',
    name: "Name",
    active: "Active",
    default: "Default",
    actions: "Actions",
    productTypeName: "Product type name",
    save: "Save",
    cancel: "Cancel",
    add: "Add",
    addProductType: "Add Product Type",
    placeholder: "e.g., UCITS Funds, ETFs, Structured Products...",
    deleteProductType: "Delete Product Type",
    deleteDescription:
      "Are you sure you want to delete this product type? This action cannot be undone.",
    delete: "Delete",
    assessment: "Assessment",
    modeSimple: "Simple",
    modeQuestionnaire: "Questionnaire",
    modeQuiz: "Quiz",
    modeBoth: "Quiz + Questionnaire",
    error: "Error",
    failedToAdd: "Failed to add product type",
    failedToUpdate: "Failed to update product type",
    failedToDelete: "Failed to delete product type",
  },
  nb_NO: {
    edit: "Rediger",
    productTypes: "Produkttyper",
    description:
      "Definer instrumentkategorier for denne samlingen. Disse brukes til å spore kundens produktvurdering og for egnethetstesting mot målmarked. Standardtypen er forhåndsvalgt når du oppretter et nytt produkt.",
    noProductTypes:
      'Ingen produkttyper konfigurert. Klikk "Legg til produkttype" for å opprette en.',
    name: "Navn",
    active: "Aktiv",
    default: "Standard",
    actions: "Handlinger",
    productTypeName: "Produkttypenavn",
    save: "Lagre",
    cancel: "Avbryt",
    add: "Legg til",
    addProductType: "Legg til produkttype",
    placeholder: "f.eks., UCITS-fond, ETF-er, strukturerte produkter...",
    deleteProductType: "Slett produkttype",
    deleteDescription:
      "Er du sikker på at du vil slette denne produkttypen? Denne handlingen kan ikke angres.",
    delete: "Slett",
    assessment: "Vurdering",
    modeSimple: "Enkel",
    modeQuestionnaire: "Spørreskjema",
    modeQuiz: "Quiz",
    modeBoth: "Quiz + Spørreskjema",
    error: "Feil",
    failedToAdd: "Kunne ikke legge til produkttype",
    failedToUpdate: "Kunne ikke oppdatere produkttype",
    failedToDelete: "Kunne ikke slette produkttype",
  },
} as const;
